import "../assets/css/pastCollaborations.css";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import { CollaborationController } from "../controllers/collaborationController";
import { useToastPromise } from "../components/toastPromise";
import { useEffect, useState } from "react";
import { ApiUtil } from "../util/apiUtil";

export const PastCollaborations = () => {
  const toastPromise = useToastPromise();
  const [pastCollaborations, setPastCollaborations] = useState([]);
  const getAllImages = () => {
    toastPromise({
      promise: new Promise((resolve, reject) => {
        CollaborationController.getAll({
          resolve: resolve,
          reject: reject,
        });
      }),
      successMessage: (data) => {
        console.debug(data);
        setPastCollaborations(ApiUtil.deserialize({ data: data }));
        return "Successful retrieve all images.";
      },
      errorMessage: (data) => data,
    });
  };
  const srcset = (image, size, rows = 1, cols = 1) => {
    return {
      src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
      srcSet: `${image}?w=${size * cols}&h=${
        size * rows
      }&fit=crop&auto=format&dpr=2 2x`,
    };
  };
  useEffect(() => {
    getAllImages();
  }, []);

  return (
    <section id="pastCollaborations">
      <div className="past-collaborations-container">
        <h3>PAST COLLABORATIONS</h3>
        <hr />
        {pastCollaborations.map((events, index) => (
          <div key={index}>
            {events.title}
            <ImageList variant="quilted" cols={4}>
              {events.galleries.map((image, index) => {
                const cols = index / 3 === 0 ? 2 : 1;
                const rows = index / 3 === 0 ? 2 : 1;
                return (
                  <ImageListItem key={index} cols={cols || 1} rows={rows || 1}>
                    <img
                      className="image-list-item"
                      {...srcset(image, 121, rows, cols)}
                      alt={events.title}
                    />
                  </ImageListItem>
                );
              })}
            </ImageList>
          </div>
        ))}
      </div>
    </section>
  );
};
